import React, { useContext } from "react";
import HeroSection from "./HeroSection";
import FeaturesSection from "./FeaturesSection";
import Reassurance from "./Reassurance";
import GroupedProducts from "./GroupedProducts";
import Testimonials from "./Testimonials";
import CTASection from "./CTASection";
import { ThemeContext } from "../../hooks/ThemeContext";

const Home = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div className={`flex-1 flex flex-col ${theme === 'dark' ? 'bg-[#0f1114] text-white' : 'bg-slate-50 text-gray-800'}`}>
      <div className="w-full max-w-7xl mx-auto px-4">
        <HeroSection />
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 mt-10">
        <FeaturesSection />
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 mt-8">
        <Reassurance />
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 mt-12">
        <Testimonials />
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 mt-8">
        <GroupedProducts />
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 mt-6">
        <CTASection />
      </div>
    </div>
  );
};

export default Home;




